"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const d3_zoom_1 = require("d3-zoom");
const useDeepMemo_1 = require("../../hooks/useDeepMemo");
const theme_1 = require("../../theme");
const mapUtils_1 = require("../../util/mapUtils");
const d3_selection_1 = require("d3-selection");
const withParentDimensions_1 = require("../generic/withParentDimensions");
const styled_components_1 = __importDefault(require("styled-components"));
const common_styled_components_1 = require("../common-styled-components");
const lodash_1 = require("lodash");
const HEIGHT_FACTOR = 0.55;
const MapContainer = styled_components_1.default.figure `
  width: 100%;
  margin: ${theme_1.theme.spacing(2)} 0;
  background-color: ${theme_1.theme.colors.darkBlue};
  padding: ${theme_1.theme.spacing(2)};
  overflow: hidden;
`;
const VoyageMap = (props) => {
    const { parentDimensions: { width }, legs, hideLegend, } = props;
    const height = HEIGHT_FACTOR * width;
    const [zoomState, setZoomState] = (0, react_1.useState)();
    const mapRef = (0, react_1.useRef)(null);
    const [mapFeatures] = (0, mapUtils_1.useMapFeatures)();
    const [mapShapes, projection] = (0, useDeepMemo_1.useDeepMemo)(() => {
        const proj = (0, mapUtils_1.getProjection)(width, height, HEIGHT_FACTOR, zoomState || { x: 0, y: 0, k: 1 });
        const shapes = (0, mapUtils_1.getShapes)(proj, mapFeatures);
        return [shapes, proj];
    }, [zoomState, mapFeatures, width, height]);
    // Use d3 for zoom and pan behavior
    (0, react_1.useEffect)(() => {
        if (mapRef.current) {
            const mapElement = (0, d3_selection_1.select)(mapRef.current);
            const zoomBehavior = (0, d3_zoom_1.zoom)()
                .scaleExtent([1, 8])
                .translateExtent([
                [0, 0],
                [width, height],
            ])
                .on("zoom", () => {
                if (mapElement?.node()) {
                    const newZoomState = (0, d3_zoom_1.zoomTransform)(mapElement.node());
                    setZoomState(newZoomState);
                }
            });
            mapElement.call(zoomBehavior);
        }
    }, [width, height]);
    return width !== undefined && width > 0 ? ((0, jsx_runtime_1.jsxs)(MapContainer, { children: [(0, jsx_runtime_1.jsxs)("svg", { width: width, height: height, ref: mapRef, style: { overflow: "hidden" }, children: [(0, jsx_runtime_1.jsxs)("g", { style: { pointerEvents: "none" }, children: [mapShapes.map((d, i) => {
                                return d !== null ? ((0, jsx_runtime_1.jsx)("path", { fill: theme_1.theme.colors.dimBlue, d: d }, i)) : undefined;
                            }), legs.map((l, i) => {
                                const startPoint = projection([
                                    l.start_longitude,
                                    l.start_latitude,
                                ]);
                                const endPoint = projection([l.end_longitude, l.end_latitude]);
                                const color = l.is_inside_eca
                                    ? theme_1.theme.colors.green
                                    : theme_1.theme.colors.grey(2);
                                return (startPoint &&
                                    endPoint &&
                                    !(0, lodash_1.isEqual)(startPoint, [0, 0]) &&
                                    !(0, lodash_1.isEqual)(endPoint, [0, 0]) && ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)("circle", { cx: startPoint[0], cy: startPoint[1], r: 2, fill: color, strokeWidth: 0 }), (0, jsx_runtime_1.jsx)("line", { x1: startPoint[0], x2: endPoint[0], y1: startPoint[1], y2: endPoint[1], stroke: color, strokeWidth: 2, strokeLinecap: "round" }, `${startPoint[0]}-${startPoint[1]}`), i === legs.length - 1 && ((0, jsx_runtime_1.jsx)("circle", { cx: endPoint[0], cy: endPoint[1], r: 2, fill: color, strokeWidth: 0 }))] }, `${startPoint[0]}-${startPoint[1]}`)));
                            })] }), (0, jsx_runtime_1.jsx)("rect", { x: 0, y: 0, width: width, height: height, fill: "rgba(0,0,0,0)" })] }), !hideLegend && ((0, jsx_runtime_1.jsxs)(common_styled_components_1.Legend, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.LegendItem, { color: theme_1.theme.colors.green, text: "Inside ECA", textColor: "white" }), (0, jsx_runtime_1.jsx)(common_styled_components_1.LegendItem, { color: theme_1.theme.colors.grey(2), text: "Outside ECA", textColor: "white" })] }))] })) : ((0, jsx_runtime_1.jsx)("div", {}));
};
exports.default = (0, withParentDimensions_1.withParentDimensions)(VoyageMap);
